// extracted by mini-css-extract-plugin
export default {"reset":"Reset_reset__LKFpO"};